const BundledProducts = class extends HTMLElement {
  constructor () {
    super()

    this.productCheckboxes = this.querySelectorAll('[data-bundled-products-checkbox]')
    this.totalPriceEl = this.querySelector('[data-bundled-products-total-price]')
    this.totalQuantityEl = this.querySelector('[data-bundled-products-total-quantity]')
    this.atcButton = this.querySelector('[data-bundled-products-atc]')
    this.atcText = this.querySelector('[data-bundled-products-atc-text]')
    this.atcTextSingle = this.querySelector('[data-bundled-products-atc-text-single]')

    this.initBundledProducts()
  }

  /**
   * Initializes all functionality
   */
  initBundledProducts () {
    if (this.productCheckboxes.length < 1) { return }

    this.checkboxListeners()
    this.atcListener()
    this.calculateTotals()
  }

  /**
   * Sets up checkbox listeners, calculate total on change
   */
  checkboxListeners () {
    this.productCheckboxes.forEach((productCheckbox) => {
      productCheckbox.addEventListener('change', () => {
        this.calculateTotals()
      })
    })
  }

  /**
   * Calculates total quantity and price of selected items
   */
  calculateTotals () {
    const selectedProducts = this.querySelectorAll('[data-bundled-products-checkbox]:checked')
    const totalPrice = Array.from(selectedProducts).reduce((total, item) =>
      total + parseInt(item.dataset.bundledProductsPrice, 10)
    , 0)
    const totalQuantity = selectedProducts.length

    this.totalPriceEl.innerHTML = `$${(totalPrice / 100).toFixed(2)}`
    this.totalQuantityEl.innerHTML = totalQuantity
    this.atcButton.toggleAttribute('disabled', totalQuantity < 1)
    this.atcText.classList.toggle('hidden', totalQuantity === 1)
    this.atcTextSingle.classList.toggle('hidden', totalQuantity !== 1)
  }

  /**
   * Sets up ATC listener, formats selected items
   */
  atcListener () {
    this.atcButton.addEventListener('click', () => {
      const selectedProducts = this.querySelectorAll('[data-bundled-products-checkbox]:checked')
      const formData = {
        items: []
      }

      selectedProducts.forEach((selectedProduct) => {
        formData.items.push({
          id: selectedProduct.dataset.bundledProductsVariantId,
          quantity: 1
        })
      })

      this.addProducts(formData)
    })
  }

  /**
   * Adds items to cart
   * @param {object} formData : object of items to add to cart
   */
  async addProducts (formData) {
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: JSON.stringify(formData),
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json'
      }
    })
    const responseJson = await response.json()

    if (response.ok) {
      if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.cartType === 'popover' || window.themeVariables.settings.pageType === 'cart') {
        return window.location.href = `${Shopify.routes.root}cart`
      }

      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json()
      cartContent['sections'] = responseJson['sections']

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent
        }
      }))
    } else {
      this.dispatchEvent(new CustomEvent('cart:error', {
        bubbles: true,
        detail: {
          error: responseJson['description']
        }
      }))
    }
  }
}

if (typeof window.customElements.get('bundled-products') === 'undefined') {
  window.customElements.define('bundled-products', BundledProducts)
}
